import {
  Info as Icon // TODO: select an icon
} from 'components/icons';

export const meta = {
  id: 'OrgTierChange',
  title: 'OrgTierChange',
  // category: 'xx',
  // exposes: [
  //   {
  //     title: 'General',
  //     action: { module: 'OrgTierChange', props: { /* */ } },
  //     desription: 'general-desc',
  //   },
  // ],
  unique: true,
  icon: Icon,
  version: '1.0.0',
  description: `This module allows users to change the current org tier`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
